/* eslint-disable no-bitwise */
// This is the same as Java #hashCode function
const hash = (stringToHash: string) => {
    // As we do an iteration per character in the input string, we limit the number of characters in the input string to 1000 characters to ensure that this function doesn't get abused
    const input = stringToHash.slice(0, 1000);

    let output = -1;
    if (input.length === 0) {
        return String(output);
    }

    for (let i = 0; i < input.length; i++) {
        const char = input.charCodeAt(i);
        output = (output << 5) - output + char;
        output &= output; // Convert to 32bit integer
    }

    return String(output);
};

export default hash;
